import React, { Fragment, Component } from 'react'
import axios from 'axios'
import { getApiBaseUrl } from '../utils/api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { mutualFundHelp, whyChooseMutual } from '../content/siteContent';

class MutualFund extends Component {
    
    constructor(){
        super();
        this.state={
            name: '',
            mobileno: '',
            email:'',
            mip:''
        }
    }

    onChangeInput = (e) => {
        const re = /^[0-9\b]+$/;
        if(e.target.name === "name"){
          this.setState({
              name: e.target.value
          });
        } else if(e.target.name === "mobileno" && (re.test(e.target.value) || e.target.value === "") && e.target.value.length <= 10){
            this.setState({
                mobileno: e.target.value
            });
         } else if(e.target.name === "email"){
             this.setState({
                 email: e.target.value
             });
         } else if(e.target.name === "mip"){
             this.setState({
                mip: e.target.value
             });
         }
    }
    
    onSendMessage = async () => {
        let enquiryDetail = {
            Name: this.state.name,
            MobileNumber: this.state.mobileno,
            EmailId: this.state.email,
            MonthlyInvestmentAmount: this.state.mip
        };
        if(enquiryDetail.Name.length == 0 || enquiryDetail.MobileNumber.length == 0 || enquiryDetail.EmailId.length == 0){
            toast.warning("Please enter Name, Mobile Number and EmailId");
            return;
        }
        await axios.post(`${getApiBaseUrl()}/hj-enquiry/createMutualfundEnq`,enquiryDetail)
            .then((res) => {
                toast.success("Mutual fund Enquiry saved Successfully! Our executive will contact you as soon as possible.");
                this.clearForm();
            }).catch((error) => {
                console.log(error);
            });
    }
    clearForm = async () =>{
        this.setState({
            name: '',
            mobileno: '',
            email:'',
            mip:''
        })
    }
    render(){
        return (
            <Fragment>
                <ToastContainer />
                <div className="boxed_wrapper ltr">
                    {/* Mobile Menu  */}
                    <div className="mobile-menu">
                    <div className="menu-backdrop"></div>
                    <div className="close-btn"><i className="fas fa-times"></i></div>

                    <nav className="menu-box">
                        <div className="nav-logo"><a href="/"><img src="assets/images/logo-4.png" alt="H.J. Enterprises" title=""/></a></div>
                        <div className="menu-outer">{/*Here Menu Will Come Automatically Via Javascript / Same Menu as in Header*/}</div>
                    </nav>
                    </div>{/* End Mobile Menu */}


                    {/* page-title */}
                    <section className="page-title centred">
                    <div className="bg-layer" style={{backgroundImage: "url(assets/images/background/page-title.jpg)"}}></div>
                    <div className="pattern-layer">
                        <div className="pattern-1" style={{backgroundImage: "url(assets/images/shape/shape-18.png)"}}></div>
                        <div className="pattern-2" style={{backgroundImage: "url(assets/images/shape/shape-17.png)"}}></div>
                    </div>
                    <div className="auto-container">
                        <div className="content-box">
                            <h1>Mutual Fund</h1>
                        </div>
                    </div>
                    </section>
                    {/* page-title end */}




                    {/* career-section */}
                    <section className="career-section pt_50 pb_50">
                    <div className="bg-layer" style={{backgroundImage: "url(assets/images/background/career-bg.jpg)"}}></div>
                    <div className="auto-container">
                        <div className="sec-title centred mb_50">
                            <h2>{mutualFundHelp.title}</h2>
                        </div>
                        <p className="mb_20" style={{ textAlign: 'center' }}>{mutualFundHelp.intro}</p>
                        <div className="sec-title centred mb_50 mt_30">
                            <h3>{mutualFundHelp.approachTitle}</h3>
                        </div>
                        <div className="inner-container">
                            {mutualFundHelp.steps.map((step) => (
                            <div className="career-block-one" key={step.title}>
                                <div className="inner-box">
                                    <div className="author-box">
                                        <div className="text-box">
                                            <h3>{step.title}</h3>
                                            <span className="designation">{step.text}</span>
                                        </div>
                                        <figure className="thumb-box"><img src={step.image} alt={step.title}/></figure>
                                    </div>
                                </div>
                            </div>
                            ))}
                        </div>
                        <div className="sec-title centred mb_20 mt_40">
                            <h3>{mutualFundHelp.closerTitle}</h3>
                        </div>
                        <p style={{ textAlign: 'center' }}>{mutualFundHelp.closer}</p>
                        <p className="mt_20" style={{ textAlign: 'center', fontSize: '14px' }}><em>{mutualFundHelp.disclaimer}</em></p>
                    </div>
                    </section>
                    {/* career-section end */}

                    {/* career-section */}
                    <section className="career-section pt_50 pb_50">
                    <div className="bg-layer" style={{backgroundImage: "url(assets/images/background/career-bg.jpg)"}}></div>
                    <div className="auto-container">
                        <div className="sec-title centred mb_50">
                            <h2>{whyChooseMutual.title}</h2>
                        </div>
                        {whyChooseMutual.intro.map((paragraph) => (
                            <p key={paragraph} className="mb_20" style={{ textAlign: 'center' }}>{paragraph}</p>
                        ))}
                        <div className="sec-title centred mb_50 mt_30">
                            <h3>{whyChooseMutual.reasonsTitle}</h3>
                        </div>
                        <div className="inner-container">
                            {whyChooseMutual.reasons.map((reason) => (
                            <div className="career-block-one" key={reason.title}>
                                <div className="inner-box">
                                    <div className="author-box">
                                        <div className="text-box">
                                            <h3>{reason.title}</h3>
                                            <span className="designation">{reason.text}</span>
                                        </div>
                                        <figure className="thumb-box"><img src={reason.image} alt={reason.title}/></figure>
                                    </div>
                                </div>
                            </div>
                            ))}
                        </div>
                        <div className="sec-title centred mb_20 mt_40">
                            <h3>{whyChooseMutual.closerTitle}</h3>
                        </div>
                        <p style={{ textAlign: 'center' }}>{whyChooseMutual.closer}</p>
                    </div>
                    </section>
                    {/* career-section end */}

                    {/* faq-form-section */}
                    <section className="faq-form-section pt_50 pb_120">
                        <div className="auto-container" id="register-form-mutualfund">
                            <div className="sec-title mb_70 centred">
                                <h2>Register Form</h2>
                            </div>
                            <div className="form-inner">
                                <div className="row clearfix">
                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                        <input 
                                            type="text" 
                                            name="name" 
                                            placeholder="Your Full Name" 
                                            required=""
                                            onChange={this.onChangeInput}
                                            value={this.state.name}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                        <input 
                                            type="text" 
                                            name="mobileno" 
                                            placeholder="Mobile Number" 
                                            required=""
                                            onChange={this.onChangeInput}
                                            value={this.state.mobileno}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                        <input 
                                            type="email" name="email" 
                                            placeholder="Your Email" 
                                            required=""
                                            onChange={this.onChangeInput}
                                            value={this.state.email}
                                        />
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                        <input 
                                            type="text" 
                                            name="mip" 
                                            placeholder="Monthly Investment Plan"
                                            onChange={this.onChangeInput}
                                            value={this.state.mip}
                                        />
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group message-btn centred">
                                        <button type="submit" className="theme-btn btn-one" onClick={this.onSendMessage}>Send Message</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* faq-form-section end */}

                    {/* main-footer */}
                    <footer className="main-footer">
                        <div className="footer-bottom centred">
                            <div className="auto-container">
                                <div className="copyright"><p>Design by : <a href="index.html">SK Computer Solution</a></p></div>
                            </div>
                        </div>
                    </footer>
                    {/* main-footer end */}

                    {/*Scroll to top*/}
                    <div className="scroll-to-top">
                        <div>
                            <div className="scroll-top-inner">
                                <div className="scroll-bar">
                                    <div className="bar-inner"></div>
                                </div>
                                <div className="scroll-bar-text">Go To Top</div>
                            </div>
                        </div>
                    </div>
                    {/* Scroll to top end */}

                </div>
            </Fragment>
        )
    }
}

export default MutualFund;